import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import { SgdsMasthead } from "@govtechsg/sgds-masthead-react";

import Navbar from "../../Components/NavbarComponent";
import FooterComponent from "../../Components/FooterComponent";
import SideNavComponent from "../../Components/SideNavComponent";
import MastheadAnnouncement from '../../Components/MastheadAnnouncement'

import Endpoint from "../../Components/Endpoint";

const CoordinateServices = () => {
  const location = useLocation();

  const endpointreturn = (id) => {
    let endpt_elem = [
      {
        page_section: "4326to3857",
        method: "GET",
        endpoint: "/api/common/convert/4326to3857",
        sampleRequest:
          "/api/common/convert/4326to3857?latitude=1.319728905&longitude=103.8421581",
        sampleResponse:
          '{\n  "Y": 146924.54200324757,\n  "X": 11559656.16256661\n}',
      },
      {
        page_section: "4326to3414",
        method: "GET",
        endpoint: "/api/common/convert/4326to3414",
        sampleRequest:
          "/api/common/convert/4326to3414?latitude=1.319728905&longitude=103.8421581",
        sampleResponse:
          '{\n  "Y": 33554.4360965479,\n "X": 28983.75169436287\n}',
      },
      {
        page_section: "3414to3857",
        method: "GET",
        endpoint: "/api/common/convert/3414to3857",
        sampleRequest:
          "/api/common/convert/3414to3857?X=28983.788791079794&Y=33554.509813284",
        sampleResponse:
          '{\n  "Y": 146924.61623595929,\n  "X": 11559656.199673364\n}',
      },
      {
        page_section: "3414to4326",
        method: "GET",
        endpoint: "/api/common/convert/3414to4326",
        sampleRequest:
          "/api/common/convert/3414to4326?X=28983.788791079794&Y=33554.5098132845",
        sampleResponse:
          '{\n  "latitude": 1.3197295716669164,\n  "longitude": 103.84215843333567\n}',
      },
      {
        page_section: "3857to3414",
        method: "GET",
        endpoint: "/api/common/convert/3857to3414",
        sampleRequest:
          "/api/common/convert/3857to3414?Y=146924.54200324757&X=11559656.16256661",
        sampleResponse:
          '{\n  "Y": 33554.4360965483,\n "X": 28983.75169436287\n}',
      },
      {
        page_section: "3857to4326",
        method: "GET",
        endpoint: "/api/common/convert/3857to4326",
        sampleRequest:
          "/api/common/convert/3857to4326?Y=146924.54200324757&X=11559656.16256661",
        sampleResponse:
          '{\n  "latitude": 1.3197289050000036,\n  "longitude": 103.8421581\n}',
      },
    ];
    endpt_elem = endpt_elem.find((item) => item.page_section === id);

    const pythonCode = `import requests
    \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
    \nheaders = {"Authorization": "**********************"}
    \nresponse = requests.request("GET", url, headers=headers)
    \nprint(response.text)`;

    const jsCode = `const url = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}";
const authToken = '**********************';  // Replace with your access token

fetch(url, {
  method: '${endpt_elem.method}',
  headers: {
    'Authorization': \`\${authToken}\`,  // API token for authorization
  }
})
.then(response => response.json())  // Parse response as JSON
.then(data => console.log(data))     // Log the data to the console
.catch(error => console.error('Error:', error));  // Log any errors`;

    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const { state } = location;
  const [activeKey, setActiveKey] = useState("");
  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };
  useEffect(() => {
    if (state === null) {
      clickButton("0");
    } else {
      clickButton(location.state.toString());
    }
  }, [state]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>
      <Helmet>
        <title>Coordinate Converters | OneMap API</title>
        <meta
          name="description"
          content="Use our Coordinate Converters API to easily convert between EPSG formats including WGS84 (EPSG:4326), EPSG:3857, and SVY21 (EPSG:3414). Access real-time coordinate conversion with error handling, secure API tokens, and sample code. Perfect for developers working with geographical data."
        />
      </Helmet>
      <MastheadAnnouncement/>
      <Navbar />
      <div className="row qx-0 mb-5 position-relative">
        <div className="col-1 d-md-none d-inline">
          <div
            className="btn btn-primary d-md-none position-fixed sideBarBtn"
            onClick={(e) => {
              handleCollapse();
              if (isCollapsed) {
                window.scrollTo(0, 0);
              }
            }}
          >
            Show Side Bar
          </div>
        </div>

        <div
          className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? "collapse" : ""
          }`}
        >
          <SideNavComponent />
        </div>

        <div className="col-12 col-md-9 qx-0 px-3">
          <>
            <div className="om-cc-section">
              <h1>Coordinate Converters</h1>
              <div className="om-cc-intro">
                <p>
                  This API provides coordinates between EPSG 3414 (SVY21), EPSG
                  3857 and EPSG 4326 (WGS84) formats.
                </p>
              </div>
              <br />
              <hr />
              <h1 id="conv4326to3857">4326(WGS84) to 3857</h1>
              <p>This API converts coordinates from EPSG:4326 to EPSG:3857.</p>
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p>
                  400 - Please send the access token in the request header as a
                  bearer token.
                </p>
                <p>
                  400 - Please input both latitude and longitude coordinates.
                </p>
                <p>
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p>
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p>
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p>429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      latitude
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>Latitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      longitude
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>Longitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("4326to3857")} />
              <h1 id="conv4326to3414">4326(WGS84) to 3414(SVY21)</h1>
              <p>This API converts coordinates from EPSG:4326 to EPSG:3414.</p>
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p>
                  400 - Please send the access token in the request header as a
                  bearer token.
                </p>
                <p>
                  400 - Please input both latitude and longitude coordinates.
                </p>
                <p>
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p>
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p>
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p>429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      latitude
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>Latitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      longitude
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>Longitude coordinates in WGS84 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("4326to3414")} />
              <h1 id="conv3414to3857">3414(SVY21) to 3857</h1>
              <p>This API converts coordinates from EPSG:3414 to EPSG:3857.</p>
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p>
                  400 - Please send the access token in the request header as a
                  bearer token.
                </p>
                <p>400 - Please input both Y and X coordinates.</p>
                <p>
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p>
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p>
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p>429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Y<span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>Y coordinates in SVY21 format.</p>
                    </div>
                  </div>
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      X<span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>X coordinates in SVY21 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("3414to3857")} />
              <h1 id="conv3414to4326">3414(SVY21) to 4326(WGS84)</h1>
              <p>This API converts coordinates from EPSG:3414 to EPSG:4326</p>
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p>
                  400 - Please send the access token in the request header as a
                  bearer token.
                </p>
                <p>400 - Please input both Y and X coordinates.</p>
                <p>
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p>
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p>
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p>429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Y<span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>Y Coordinates in SVY21 format.</p>
                    </div>
                  </div>
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      X<span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>X Coordinates in SVY21 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("3414to4326")} />
              <h1 id="conv3857to3414">3857 to 3414(SVY21)</h1>
              <p>This API converts coordinates from EPSG:3857 to EPSG:3414</p>
              <h3 className="om-theme-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p>
                  400 - Please send the access token in the request header as a
                  bearer token.
                </p>
                <p>400 - Please input both Y and X coordinates.</p>
                <p>
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p>
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p>
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p>429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Y<span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>Y Coordinates in SVY21 format.</p>
                    </div>
                  </div>
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      X<span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>X Coordinates in SVY21 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("3857to3414")} />
              <h1 id="conv3857to4326">3857 to 4326(WGS84)</h1>
              <p>This API converts coordinates from EPSG:3857 to EPSG:4326</p>
              <h3 className="om-cc-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p>
                  400 - Please send the access token in the request header as a
                  bearer token.
                </p>
                <p>400 - Please input both Y and X coordinates.</p>
                <p>
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p>
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p>
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p>429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-reverseGeocode-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-reverseGeocode-items">
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      Y<span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>Y coordinates in SVY21 format.</p>
                    </div>
                  </div>
                  <div className="om-reverseGeocode-item">
                    <div className="label-method">
                      X<span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-reverseGeocode-desc">
                      <p>X coordinates in SVY21 format.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("3857to4326")} />
            </div>
          </>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};
export default CoordinateServices;
